/* ELIO offer engine
   Central client-side source of truth for storefront offer projections.
   Shopify's returned cart totals/allocations remain authoritative after a cart mutation.

   Modes per fabric family:
     bundle       flat dollars off every complete pair
     bogo_percent buy one, get one X% off; the lowest-priced floor(n/2) eligible units receive X% off
     off          no projected offer

   Original Cotton and Bamboo Cotton never cross-complete an offer pair. */
(function () {
  'use strict';

  function readConfig() {
    var el = document.getElementById('elio-pair-offer-config');
    var raw = {};
    if (el) {
      try { raw = JSON.parse(el.textContent || '{}') || {}; } catch (e) { raw = {}; }
    }
    var legacy = Math.max(0, Number(raw.pairDiscountCents || 1000));
    function family(key, fallbackDiscount) {
      var src = raw[key] || {};
      var mode = String(src.mode || 'bundle');
      if (['bundle', 'bogo_percent', 'off'].indexOf(mode) === -1) mode = 'bundle';
      return {
        mode: mode,
        bundleDiscountCents: Math.max(0, Number(src.bundleDiscountCents != null ? src.bundleDiscountCents : fallbackDiscount)),
        bogoPercent: Math.min(100, Math.max(0, Number(src.bogoPercent != null ? src.bogoPercent : 50)))
      };
    }
    return {
      original: family('original', legacy),
      bamboo: family('bamboo', legacy)
    };
  }

  var CONFIG = readConfig();

  function familyKey(value) {
    if (value && typeof value === 'object') {
      if (value.elioFamily) return familyKey(value.elioFamily);
      value = [value.product_title, value.title, value.handle, value.product_type].filter(Boolean).join(' ');
    }
    var text = String(value || '').toLowerCase();
    return text.indexOf('bamboo') !== -1 ? 'bamboo' : 'original';
  }

  function familyConfig(family) {
    return familyKey(family) === 'bamboo' ? CONFIG.bamboo : CONFIG.original;
  }

  function validPrices(prices) {
    return (prices || []).map(function (p) { return Number(p || 0); }).filter(function (p) { return p > 0; });
  }

  function discountForFamily(prices, family) {
    var vals = validPrices(prices);
    var cfg = familyConfig(family);
    var pairs = Math.floor(vals.length / 2);
    if (!pairs || cfg.mode === 'off') return 0;
    if (cfg.mode === 'bundle') return pairs * cfg.bundleDiscountCents;

    // Match standard same-pool BOGO behavior: discount the cheapest eligible
    // floor(n/2) units. This must be mirrored by the Shopify automatic discount.
    vals.sort(function (a, b) { return a - b; });
    var base = vals.slice(0, pairs).reduce(function (sum, p) { return sum + p; }, 0);
    return Math.round(base * cfg.bogoPercent / 100);
  }

  function discountForItems(items) {
    var groups = { original: [], bamboo: [] };
    (items || []).forEach(function (entry) {
      if (entry == null) return;
      if (typeof entry === 'number') {
        groups.original.push(entry);
        return;
      }
      var family = familyKey(entry.family || entry);
      var price = Number(entry.price != null ? entry.price : entry.original_price || 0);
      var qty = Math.max(1, Number(entry.quantity || 1));
      if (price > 0) for (var i = 0; i < qty; i++) groups[family].push(price);
    });
    return discountForFamily(groups.original, 'original') + discountForFamily(groups.bamboo, 'bamboo');
  }

  function pairDiscount(a, b, family) {
    return discountForFamily([a, b], family);
  }

  function percentText(n) {
    var v = Number(n || 0);
    return (Math.round(v * 100) / 100).toString().replace(/\.0+$/, '') + '%';
  }

  function offerLabel(family, style) {
    var cfg = familyConfig(family);
    if (cfg.mode === 'off') return '';
    if (cfg.mode === 'bogo_percent') {
      var pct = percentText(cfg.bogoPercent);
      if (style === 'short') return 'BOGO ' + pct + ' off';
      if (style === 'add_one') return 'Add one more. Get the second ' + pct + ' off.';
      if (style === 'applied') return 'Buy one, get one ' + pct + ' off applied.';
      return 'Buy one, get one ' + pct + ' off';
    }
    var dollars = cfg.bundleDiscountCents / 100;
    var amount = '$' + (dollars % 1 ? dollars.toFixed(2).replace(/0+$/, '').replace(/\.$/, '') : dollars.toFixed(0));
    if (style === 'short') return amount + ' off every pair';
    if (style === 'add_one') return 'Add one more and save ' + amount + '.';
    if (style === 'applied') return 'Pair pricing applied.';
    return 'Save ' + amount + ' on every two briefs';
  }

  window.ElioOffer = {
    config: CONFIG,
    familyKey: familyKey,
    familyConfig: familyConfig,
    discountForFamily: discountForFamily,
    discountForItems: discountForItems,
    pairDiscount: pairDiscount,
    offerLabel: offerLabel
  };
})();
